import { render, staticRenderFns } from "./wanEditor2.vue?vue&type=template&id=71266745&lang=html"
import script from "./wanEditor2.vue?vue&type=script&lang=js"
export * from "./wanEditor2.vue?vue&type=script&lang=js"
import style0 from "./wanEditor2.vue?vue&type=style&index=0&id=71266745&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports